import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Configure Axios defaults
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [userType, setUserType] = useState(null); // 'staff' or 'applicant'
    const [loading, setLoading] = useState(true);

    const checkAuth = async () => {
        try {
            const res = await axios.get('/api/me');
            if (res.data.authenticated) {
                setUserType(res.data.user_type);
                setUser(res.data.user_type === 'staff' ? res.data.user : res.data.applicant);
            } else {
                setUser(null);
                setUserType(null);
            }
        } catch (err) {
            setUser(null);
            setUserType(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    const loginStaff = async (login, password) => {
        const res = await axios.post('/api/login', { login, password });
        if (res.data.success) {
            setUserType('staff');
            setUser(res.data.user);
        }
        return res.data;
    };

    const loginApplicant = async (login, password) => {
        const res = await axios.post('/api/applicant-login', { login, password });
        if (res.data.success) {
            setUserType('applicant');
            setUser(res.data.applicant);
        }
        return res.data;
    };

    const logout = async () => {
        try {
            await axios.post('/api/logout');
        } finally {
            setUser(null);
            setUserType(null);
        }
    };

    return (
        <AuthContext.Provider value={{ user, userType, loading, loginStaff, loginApplicant, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
